import redirects from '../routes/redirects/redirects-url.json';

interface Redirect {
  oldUrl: string;
  newUrl: string;
}

interface RedirectsConfig {
  redirects: Redirect[];
}

/**
 * Checks if the current URL needs to be redirected based on the redirects configuration
 * @returns {boolean} - Returns true if a redirect was performed, false otherwise
 */

export const handleRedirects = (): boolean => {
  const currentUrl = window.location.href;
  const redirect = (redirects as RedirectsConfig).redirects.find((redirect) => redirect.oldUrl === currentUrl);

  if (redirect) {
    window.location.href = redirect.newUrl;
    return true;
  }

  return false;
};
